import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { IAppState } from 'app/store/app/app.state';
import { selectRouteConfigs } from 'app/store/auth/auth.selectors';
import { SetSelectedPrimaryNavConfig } from 'app/store/sidebar/sidebar.actions';
import { selectActiveSecondaryNavMenuId } from 'app/store/sidebar/sidebar.selectors';
import { filter } from 'rxjs/operators';
import { HasSubscriptions } from 'shared/components/higher-order/has-subscriptions';
import { InfoPostNavConfig } from "../sidebar-nav/nav-menus.constants";
import { Observable } from 'rxjs';

@Component({
  selector: 'app-infopost-sidebar-nav-secondary-item',
  templateUrl: './sidebar-nav-secondary-item.component.html',
  styleUrls: ['./sidebar-nav-secondary-item.component.scss'],
})
export class InfoPostSidebarNavSecondaryItemComponent extends HasSubscriptions {
  @Input()
  config: InfoPostNavConfig;

  @Input()
  selectedPrimaryNavConfigId: string;

  @Input()
  menuGuards: { [name: string]: Observable<boolean> };

  activeSecondaryNavMenuId$ = this._store.pipe(select(selectActiveSecondaryNavMenuId));
  routeConfigs$ = this._store.pipe(
    select(selectRouteConfigs),
    filter(Boolean)
  );

  constructor(private _store: Store<IAppState>, private _router: Router) {
    super();
  }

  clearSelectedPrimaryNavConfig(): void {
    this._store.dispatch(new SetSelectedPrimaryNavConfig(null));
  }

  navigate(route: string): void {
    this._router.navigate([route]);
    this.clearSelectedPrimaryNavConfig();
  }

  navigateAway(href: string): void {
    window.open(href);
  }
}
